define('SageDotCom/Components/FlexBox',["jquery", "eventManager"],
    function ($, eventManager) {

        function FlexBox(scope, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
            ///<summary>Initialize a new instance of FlexBox. Subscribe to messages which are passed to current instance.</summary>

            var self = this;
            Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });
            Object.defineProperty(this, "stateChangeMessages", { enumerable: true, value: stateChangeMessages.slice() });

            //#region show messages performer
            if (onShowMessagesPerformer.length) {
                onShowMessagesPerformer.forEach(function (messageName) {
                    eventManager.subscribe(messageName, self.show, self);
                });

            }
            //#endregion


            //#region hide mesage performer
            if (onHideMessagePerformer.length) {
                onHideMessagePerformer.forEach(function (messageName) {
                    eventManager.subscribe(messageName, self.hide, self);
                });
            }
            //#endregion
        }

        FlexBox.prototype.show = function () {
            ///<summary>Make FlexBox visible with jQuery.show() method.</summary>
            this.$scope.show();

            var self = this;
            if (this.stateChangeMessages.length) {
                this.stateChangeMessages.forEach(function (ev) {
                    eventManager.trigger(ev, self);
                });
            }
        };

        FlexBox.prototype.hide = function () {
            ///<summary>Make FlexBox hidden with jQuery.hide() method.</summary>
            this.$scope.hide();

            var self = this;
            if (this.stateChangeMessages.length) {
                this.stateChangeMessages.forEach(function (ev) {
                    eventManager.trigger(ev, self);
                });
            }
        };

        FlexBox.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new FlexBox(args.scope,
                    args.StateChangeMessagesTransmitting || [],
                    args.ShowActionMessages || [],
                    args.HideActionMessages || []);
        };

        return FlexBox;
});
